export default "__VITE_ASSET__CsJv7dsy__"